export var AssessmentActivityType;
(function (AssessmentActivityType) {
    AssessmentActivityType["Interview"] = "interview";
    AssessmentActivityType["Meeting"] = "meeting";
    AssessmentActivityType["Reminder"] = "reminder";
    AssessmentActivityType["Review"] = "review";
    AssessmentActivityType["Task"] = "task";
})(AssessmentActivityType || (AssessmentActivityType = {}));
//# sourceMappingURL=assessment-activity-type.js.map